import React from 'react'
import LeftBar from '../Components/LeftBar'
import Dashnav from '../Components/Dashnav'
import IntervComp from './IntervComp'
import './dash.css'

function Interviews() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <IntervComp/>
        </div>
    </div>
  )
}

export default Interviews
